import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import hey from "@/lib/hey";

export default function (element: HTMLElement, dataset: any) {
  let headings = document.querySelectorAll(".loader_text");
  let tl = gsap.timeline({
    paused: true,
    onComplete() {
      hey.loaderComplete = true;
    },
  });

  tl.to(headings, {
    yPercent: -110,
    stagger: 0.2,
  });

  tl.to(
    headings[0],
    {
      x: getDistanceFromRightEdge(
        headings[0],
        element.querySelector(".loader_inner"),
      ),
      duration: 1,
      ease: "power2.inOut",
    },
    ">-0.5",
  );

  tl.to(".loader_text_white", {
    clipPath: "inset(0% 0 0 0)",
  });

  tl.to(
    ".loader_text_wrap",
    {
      scale: 1.1,
    },
    ">-0.7",
  );

  tl.to(
    element,
    {
      autoAlpha: 0,
      duration: 0.4,
    },
    ">-0.7",
  );

  onMount(() => {
    tl.play();
  });
}

function getDistanceFromRightEdge(
  element: Element,
  container: Element | null = document.body,
) {
  let elementRect = element.getBoundingClientRect();
  let containerRect = container.getBoundingClientRect();

  console.log(elementRect.right, containerRect.right);

  let calculation = elementRect.right - containerRect.right;

  return -calculation - 64;
}
